module.exports = __webpack_public_path__ + "img/02.d043a69c.jpg";